<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="text-h6 font-weight-black">Ocupação das salas</v-card-text>

      <v-row>
        <v-col>
          <v-card-text class="text-h4 font-weight-black"> {{ taxa ?? 0 }}% </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "TaxaOcupacao",
  mounted() {
    this.getTaxa();
  },
  data() {
    return {
      loading: true,
      taxa: 0,
    };
  },
  methods: {
    async getTaxa() {
      const data = await this.$services.turmasService.taxaOcupacao();
      if (data) {
        this.taxa = data;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
div.chart-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
